export default "/_next/static/images/356afd5e819ff3a838375f2aa00369ac.jpg";